module.exports = __webpack_public_path__ + "static/media/20180203_100315.2289039b.jpg";